import { render, staticRenderFns } from "./basic-data-form.vue?vue&type=template&id=f98f0664&scoped=true&"
import script from "./basic-data-form.ts?vue&type=script&lang=ts&"
export * from "./basic-data-form.ts?vue&type=script&lang=ts&"
import style0 from "./basic-data-form.scss?vue&type=style&index=0&id=f98f0664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98f0664",
  null
  
)

export default component.exports